//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

import { convertTime, convertRequestPriority } from '../../components/helpers.js'
import { axiosGet } from '../../axios/axios.js'
import GeoPointField from '../../components/Field/GeoPointField.vue'
import DateTimeField from '../../components/Field/DateTimeField.vue'
import TableComponentServerSingleWithFilter from '../../components/TableComponent/TableComponentServerSingleWithFilter.vue'
// import RequestCreateObject from './RequestCreateObject.vue'
import RequestAddRoadsLabels from './RequestAddRoadsLabels.vue'
import RequestDescriptionField from './RequestDescriptionField.vue'
import RequestRemontPositionField from './RequestRemontPositionField.vue'
import ReportContentSection from '../Report/ReportContent/ReportContentSection.vue'

import {
  loadRequestTypeConfiguration,
  loadRequestTypeProjects,
  filterProjectsByUserAccess,
  checkRequestTypeProject,
  computeCloseConditionTime
} from './Request.js'
import { filterRequestTypesByUserAccess } from './RequestType.js'
import { matchLocations } from './Sup/SupLocation.js'

function isLocationsEqual (location1, location2) {
  if (location1 == null && location2 == null) {
    return true
  } else if (location1 == null || location2 == null) {
    return false
  } else if (location1.lon === location2.lon && location1.lat === location2.lat) {
    return true
  }
  return false
}

export default {
  components: {
    GeoPointField,
    TableComponentServerSingleWithFilter,
    // RequestCreateObject,
    DateTimeField,
    RequestDescriptionField,
    RequestRemontPositionField,
    RequestAddRoadsLabels,
    ReportContentSection
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default () {
        return ''
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    isInitialize: {
      type: Boolean,
      default: false
    },
    isAudit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      priorityText: '',
      tempServiceObject: null,
      modalServiceObjectSelectionOpened: false,
      // modalServiceObjectAdd: false,
      serviceObjectTableColumns: [
        {
          name: 'alias',
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'alias',
          sortable: true
        },
        {
          name: 'fvfComplexNumber',
          label: 'Номер комплекса',
          labelTable: 'Номер</br>комплекса',
          align: 'left',
          defaultWidth: 80,
          field: 'fvfComplexNumber',
          sortable: true
        },
        {
          name: 'typeAlias',
          label: 'Тип',
          align: 'left',
          defaultWidth: 40,
          field: 'typeAlias',
          sortable: true
        },
        {
          name: 'address',
          label: 'Адрес',
          align: 'left',
          defaultWidth: 600,
          field: 'address',
          sortable: true
        }
      ],

      availableRequestTypes: [],
      requestAddRoadsLabelsDialogOpened: false,
      workAreas: [],
      requestTypeProjectsOptions: []
    }
  },
  computed: {
    ...mapGetters({
      requestDeliveryVISes: 'getRequestDeliveryVISes',
      requestTypes: 'getRequestTypes',
      workTypes: 'getWorkTypes',
      requestSources: 'getRequestSources'
    }),
    showObjectStatus: function () {
      return this.taskStatus === 'BS0' || this.taskStatus === 'BS1' || this.taskStatus === 'BS2'
    },
    isRequestCreation: function () {
      return this.taskStatus === 'BS0'
    },
    isRequestCreated: function () {
      return !this.isRequestCreation
    },
    /**
     * Собственные данные завки
     * Данные уже созданных заявок, либо создаваемых, но не путем инициации/аудита
     */
    showServiceObjectData: function () {
      return !this.isAudit || this.isRequestCreated
    },
    showRequestOwnData: function () {
      return (!(this.isAudit || this.isInitialize) || this.isRequestCreated)
      // return (!this.isAudit || this.isRequestCreated) && (!this.isInitialize || this.isRequestCreated)
      // return (!this.isAudit || this.taskStatus !== 'BS0') && (!this.isInitialize || this.taskStatus !== 'BS0')
      // return (!this.isAudit || this.taskStatus !== 'BS0') && !this.isInitialize
    },
    showRoadsLabels: function () {
      return this.showRequestOwnData && (this.requestRoles.roleDispatcherOrHigher || this.requestRoles.roleReportCheckerOrHigher) && this.request.isRoadsIntegrationAvailable && this.request.requestVisId && this.request.isFieldIncluded('roadsLabels')
    },
    hasInitiatorRequests: function () {
      return this.request.initiatorRequests && this.request.initiatorRequests.length !== 0
    },
    applicantDescriptionReadonly: function () {
      // TODO this.request.deliveryVIS.key === 'delta2internal'
      return !this.requestRoles.hasEditAccess ||
        !(this.isRequestCreation || ((this.taskStatus === 'BS1' || this.taskStatus === 'BS2') && (this.request.requestSource && this.request.requestSource.key === 'deltaSDPEmployee'))) // TODO
    },
    // externalDispatcherBounded: function () {
    //   const user = this.$store.getters.getUser
    //   return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    // },
    projectSelectionSource: function () {
      return this.request._configuration && this.request._configuration.projectSelectionSource || 'serviceObjectOrType' // По умолчанию: сначала поиск по ОО при наличии, иначе - поиск по Типу заявки
    },
    projectFieldReadonlyByRequestConfig: function () {
      switch (this.projectSelectionSource) {
        case 'type':
          return !this.request.requestTypeObject
        case 'serviceObject':
          return !this.request.serviceObject
        case 'serviceObjectOrType':
          return !this.request.requestTypeObject
        default:
          return true
      }
    },
    projectsFieldOptions: function () {
      let projects
      if (this.projectSelectionSource === 'type' || this.projectSelectionSource === 'serviceObjectOrType') {
        projects = this.requestTypeProjectsOptions
      } else { // == if (this.projectSelectionSource === 'serviceObject')
        projects = this.request.serviceObject && this.request.serviceObject.projects || [] // projects 1
      }

      // Фильтруем по доступу
      const currentProject = this.request.project || null
      const currentProjectId = currentProject ? currentProject.id : null
      const user = this.$store.getters.getUser
      projects = filterProjectsByUserAccess(projects, user, currentProjectId)

      return projects
    },
    requiredAnotherPerformerTranslationFieldAvailable: function () {
      return this.request.requestSource && this.request.requestSource.id === 74764 // Портал "Наш город"
    },
    requestTypeReadonly: function () {
      return !this.requestRoles.hasEditAccess // || this.requestRoles.roleRestrictedDispatcher
    },
    supTaskLocationValidationData: function () {
      if (this.request.supTaskData) {
        const supTaskVersions = this.request.supTaskData.supTask
        const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[supTaskVersions.length - 1] || null
        return matchLocations(supTask, this.request.location)
      }
      return null
    }
    // requestLocation: {
    //   get: function () {
    //     if (this.request.location) {
    //       return this.request.location
    //     }
    //     return this.request.serviceObject ? this.request.serviceObject.location : null
    //   },
    //   set: function (value) {
    //     // TODO изменить координаты в заявке ?
    //     this.request.location = value
    //   }
    // }
  },
  watch: {
    'request.serviceObjectId': function () {
      this.computeAvailableRequestTypes()
      this.onChangeServiceObject()
    },
    'request.requestTypeObject': {
      handler: function (requestType, requestTypeOld) {
        if (!requestType && !requestTypeOld || requestType === requestTypeOld || //
        requestType && requestTypeOld && requestType.id == requestTypeOld.id //
        ) {
          return
        }
        this.onRequestTypeChange(requestType)
      },
      immediate: true
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.updateTextarea(this.$refs.serviceObjectAddressField)
      this.updateTextarea(this.$refs.requestAddressField)
      this.updateTextarea(this.$refs.applicantDescriptionField)
    })
  },
  created: function () {
    // TODO const requestPriority = REQUEST_PRIORITIES.find(o => o.value === this.request.requestPriority)
    this.priorityText = convertRequestPriority(this.request.requestPriority)

    if (!this.isRequestCreated) {
      const user = this.$store.getters.getUser
      let defaultRequestSource = user.employee && user.employee.defaultRequestSource || null
      if (!defaultRequestSource) {
        defaultRequestSource = this.requestSources.find(o => o.key === 'deltaSDPEmployee') || null
      }
      this.request.requestSource = defaultRequestSource

      if (this.request.initServiceObject) {
        this.onSaveServiceObjectSelection(this.request.initServiceObject)
      }
    } else if (this.request.requestSource) {
      // TODO remove
      this.request.requestSource = this.requestSources.find(o => o.id === this.request.requestSourceId)
    }

    // Типы вычисленные при нажатии кнопки "Аудит" в диспетчерской (чтобы 2 раза не вызывать)
    if (this.request.requestTypes) {
      this.availableRequestTypes = this.request.requestTypes
    } else {
      this.computeAvailableRequestTypes()
    }
  },
  methods: {
    convertTime: convertTime,
    updateTextarea: function (cmp) {
      if (cmp) {
        const textarea = cmp.$el.querySelector('.q-field__native')
        textarea.style.height = textarea.scrollHeight + 'px'
      }
    },
    onConfirmAddRoadsLabels: function (roadsLabels) {
      this.$set(this.request, 'roadsLabels', roadsLabels)
      this.requestAddRoadsLabelsDialogOpened = false
    },
    onChangeServiceObject: function () {
      this.$emit('change-serviceObject', this.request.serviceObject)

      if (!this.serviceObject) {
        if (this.projectSelectionSource === 'type') {
          this.request.project = null
        }
        if (this.projectSelectionSource === 'serviceObjectOrType') { // || this.projectSelectionSource === 'serviceObject'
          const requestTypeId = this.request.requestTypeObject ? this.request.requestTypeObject.id : null
          const serviceObjectId = this.request.serviceObjectId
          loadRequestTypeProjects(requestTypeId, serviceObjectId, this).then(projects => {
            this.requestTypeProjectsOptions = projects // projects 2
          })
        }
        return
      }

      if (this.projectSelectionSource === 'serviceObject' && this.projectSelectionSource === 'type') {
        const serviceObjectProjectsIds = this.request.serviceObject.projects && this.request.serviceObject.projects.map(o => o.id) || []
        if (!serviceObjectProjectsIds.includes(this.request.project.id)) {
          this.request.project = null
        }
      }
      // this.request.project =  || null
    },
    computeAvailableRequestTypes: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const urlParams = new URLSearchParams()
      urlParams.set('isAudit', this.isAudit)
      urlParams.set('includeWorkAreas', true)
      if (this.request.requestsToAudit) {
        urlParams.set('requestIds', JSON.stringify(this.request.requestsToAudit))
      }
      if (this.request.serviceObjectId) {
        urlParams.set('serviceObjectIds', this.request.serviceObjectId)
      }
      const includeCommonConfiguration = !this.request.requestTypeObject
      if (includeCommonConfiguration) {
        urlParams.set('includeCommonConfiguration', includeCommonConfiguration)
      }

      if (this.request.synchronizedRequestWorkArea) {
        urlParams.set('formId', 'synchronizedRequest')
      }

      axiosGet({
        url: '/service/delta/request/getRequestsTypes?' + urlParams.toString(),
        onSuccess: (response) => {
          const requestTypes = response.data.result
          const currentRequestTypeId = this.request.requestTypeObject && this.request.requestTypeObject.id || null

          // Фильтруем по доступу
          const user = this.$store.getters.getUser
          const availableRequestTypes = filterRequestTypesByUserAccess(requestTypes, user, currentRequestTypeId)

          this.availableRequestTypes = availableRequestTypes

          if (includeCommonConfiguration) {
            const configuration = response.data.commonConfiguration
            if (configuration) {
              this.request.setRawConfiguration(configuration)
            }
          }
        },
        onFailure: 'Ошибка вычисления возможных типов заявок',
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    selectRequestTypeAudit: function (requestType, groupKey) {
      this.request.requestTypeObject = requestType

      if (this.request.requestsToAudit || this.request.objectsToAudit) {
        // Массовое создание заявок на аудит
        // initiatorRequests проставляется на сервере, но отправляется доп.параметр isAudit (аудит/аудит объекта)
        if (requestType && groupKey) {
          this.request.isAudit = groupKey === 'audit'
        }
      } else {
        // Одиночное
        if (this.request.initiatorRequests.map(req => req.id).includes(this.request.requestToAudit)) {
          this.request.initiatorRequests.pop()
        }

        if (groupKey === 'auditObject' && this.request.requestToAudit != null) {
          this.request.initiatorRequests.push({ id: this.request.requestToAudit })
        }
      }
    },
    onRequestTypeChange: function (requestType) {
      const requestTypeId = requestType ? requestType.id : null
      loadRequestTypeConfiguration(requestTypeId, this)
        .then(configuration => {
          this.request.setRawConfiguration(configuration)
        })

      const serviceObjectId = this.request.serviceObjectId
      loadRequestTypeProjects(requestTypeId, serviceObjectId, this)
        .then(projects => {
          this.requestTypeProjectsOptions = projects // projects 3
        })

      if (!this.isRequestCreated && !this.requestRoles.roleRestrictedOrExternalDispatcher) {
        computeCloseConditionTime(requestType, this.request, this)
      }

      if (!requestType) {
        this.request.project = null
      } else {
        if (this.request.project && (this.projectSelectionSource === 'type' || this.projectSelectionSource === 'serviceObjectOrType')) {
          checkRequestTypeProject(requestTypeId, this.request.project.id, this).then(isProjectValid => {
            if (!isProjectValid) {
              this.request.project = null
            }
          })
        }
      }
    },
    onShowServiceObjectsTable: function () {
      this.tempServiceObject = this.request.serviceObject
      this.modalServiceObjectSelectionOpened = true
    },
    onCloseServiceObjectModal: function () {
      this.tempServiceObject = null
      this.modalServiceObjectSelectionOpened = false
    },
    onServiceObjectSelected: function (serviceObject) {
      this.tempServiceObject = serviceObject
    },
    onServiceObjectUnselected: function () {
      this.tempServiceObject = null
    },
    onSaveServiceObjectSelection: function (initServiceObject) {
      const selectedServiceObject = initServiceObject || this.tempServiceObject
      const prevServiceObjectLocation = this.request.serviceObjectLocation

      if (selectedServiceObject) {
        if (this.request.serviceObjectType !== selectedServiceObject.type) {
          // TODO
          // if (this.request.serviceObjectType) {
          //   this.request.requestTypeObject = null
          // }
          this.request.workTypes = []
        }

        this.$q.loading.show({ spinnerColor: 'blue-11' })
        axiosGet({
          url: '/service/delta/dispatcher/serviceObjectForRequest?type=' + selectedServiceObject.type + '&id=' + selectedServiceObject.key, // TODO проверить сразу
          onSuccess: (response) => {
            const serviceResult = response.data.result

            if (serviceResult.warnings && serviceResult.warnings.length) {
              this.$d_ask({
                warning: serviceResult.warnings,
                buttons: [
                  { key: 'cancel', name: 'Понятно', color: 'green' }
                ]
              })
            }

            const serviceObject = serviceResult.serviceObject
            Object.assign(serviceObject, selectedServiceObject)
            const request = this.request
            request.serviceObject = serviceObject
            request.serviceObjectPriority = serviceObject.priority // ServiceObjectEntity.DEFAULT_PRIORITY == 1
            this.updateLocation(request.serviceObjectLocation, prevServiceObjectLocation)

            const hasMetroFields = serviceObject.type === 'stationMetro' || serviceObject.type === 'cameraMetro' || serviceObject.type === 'vestibuleMetro'
            // Дополнительные поля
            if (hasMetroFields || request.hasAdditionalField('complexAddress')) {
              request.complexAddress = serviceObject.complexAddress
            }
            if (hasMetroFields || request.hasAdditionalField('facePayCamerasCount')) {
              request.facePayCamerasCount = serviceObject.facePayCamerasCount
            }
            if (hasMetroFields || request.hasAdditionalField('commonCamerasCount')) {
              request.commonCamerasCount = serviceObject.commonCamerasCount
            }
            if (hasMetroFields || request.hasAdditionalField('commonCameras1Count')) {
              request.commonCameras1Count = serviceObject.commonCameras1Count
            }
            if (this.request.serviceObject.projects) {
              this.request.project = this.request.serviceObject.projects[0]
            }
          },
          onFailure: 'Ошибка получения информации об объекте обслуживания в заявке',
          msgTarget: this
        }).finally(() => this.$q.loading.hide())
      } else {
        this.availableRequestTypes = this.requestTypes
        this.availableWorkTypes = this.workTypes

        this.request.project = null

        this.request.serviceObject = null
        // this.request.serviceObjectPriority = 1 // TODO ServiceObjectEntity.DEFAULT_PRIORITY == 1 ?
        this.updateLocation(null, prevServiceObjectLocation)

        // Дополнительные поля
        const request = this.request
        if (request.hasAdditionalField('complexAddress')) {
          request.complexAddress = null
        }
        if (request.hasAdditionalField('facePayCamerasCount')) {
          request.facePayCamerasCount = null
        }
        if (request.hasAdditionalField('commonCamerasCount')) {
          request.commonCamerasCount = null
        }
        if (request.hasAdditionalField('commonCameras1Count')) {
          request.commonCameras1Count = null
        }

        // this.request.requestTypeObject = null // TODO ???
        // this.request.serviceObjectType = null // TODO
      }

      this.tempServiceObject = null
      this.modalServiceObjectSelectionOpened = false
    },
    // onShowServiceObjectsAdd: function () {
    //   this.modalServiceObjectSelectionOpened = false
    //   this.modalServiceObjectAdd = true
    // },
    // onCloseServiceObjectNew: function () {
    //   this.tempServiceObject = null
    //   this.modalServiceObjectAdd = false
    //   this.tempServiceObject = this.request.serviceObject
    //   this.modalServiceObjectSelectionOpened = true
    // },
    // onSaveServiceObjectNew: function () {
    //   const obj = this.$refs.creationObject.save()
    //   if (obj) {
    //     this.onSaveServiceObjectSelection(obj)
    //   }
    //   this.tempServiceObject = null
    //   this.modalServiceObjectAdd = false
    // },
    updateLocation: function (serviceObjectLocation, prevServiceObjectLocation) {
      let ask = false
      if (isLocationsEqual(prevServiceObjectLocation, this.request.location)) {
        ask = !!(this.request.location && !serviceObjectLocation) // 2
      } else {
        ask = !!(this.request.location || serviceObjectLocation) // 1
      }

      if (ask) {
        const message = serviceObjectLocation ? 'Применить координаты объекта к заявке?' //
          : this.request.serviceObject ? 'У объекта нет координат. Сбросить координаты неисправности?' : 'Сбросить координаты неисправности?'

        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.request.location = serviceObjectLocation
              this.request.requestAddress = this.request.serviceObjectAddress
            }
          },
          header: message,
          buttons: { yes: 'Да', no: 'Нет' }
        })
      } else { // if (!isLocationsEqual(serviceObjectLocation, this.request.location))
        this.request.location = serviceObjectLocation
        this.request.requestAddress = this.request.serviceObjectAddress
      }
    }
  }
}
